import {defineStore} from 'pinia'
import {dialogFlowAxios} from "@/main";

export const useIntentStore = defineStore({
    id: 'intents',

    state: () => ({
        intents: null,
        countTotList: 0,
        currentPageList: 1,
        nameIntentClickFromList: '',
        intent: null,
        addIntent: false,
        errorMessage: '',
        errorNetworkIntent: false
    }),
    actions: {
        postDetectIntent(payload, session, token) {
            return new Promise((resolve, reject) => {
                const config = {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
                dialogFlowAxios.post('v2/' + session + ":detectIntent", config)
                    .then(res => {
                        resolve(res)
                    })
                    .catch(err => {
                        if (err.response && (err.response.data.error.code === 401 || err.response.data.error.code === 500)) {
                            this.errorNetworkIntent = true
                        }
                        reject(err)
                    })
            })
        }
    },

    getters: {
        intentsGetters: state => {
            return state.intents
        },
        intentGetters: state => {
            return state.intent
        },
        addIntentGetters: state => {
            return state.addIntent
        },
        countTotListGetters: state => {
            return state.countTotList
        },
        nameIntentClickFromListGetters: state => {
            return state.nameIntentClickFromList
        },
        errorMessageGetters: state => {
            return state.errorMessage
        },
        currentPageListGetters: state => {
            return state.currentPageList
        },
        errorNetworkIntentGetters: state => {
            return state.errorNetworkIntent
        }
    }
})


